import React, { useEffect } from 'react'

const ModalSide = ({
	children,
	className = '',
	isOpen = false,
	onClose
}) => {

	useEffect(() => {
		document.body.classList.toggle('noScroll', isOpen)
	}, [isOpen])

	const closeModal = e => {
		if (e.target.closest('.ModalSide__Container') !== null) {
			return
		}
		onClose()
	}

	return (
		<div
			className={`ModalSide ${className} ${isOpen ? 'isOpen' : ''}`}
			onClick={closeModal}
		>
			<div className="ModalSide__Container">
				{children}
			</div>
			<div className="ModalSide__Close"></div>
		</div>
	)
}

export default ModalSide